var map = {
	"./layout_background.svg": 39223,
	"./layout_background_s.svg": 10470,
	"./layout_center.svg": 4569,
	"./layout_center_s.svg": 19070,
	"./layout_left.svg": 60567,
	"./layout_leftCover.svg": 34303,
	"./layout_leftCover_s.svg": 30782,
	"./layout_left_s.svg": 96897,
	"./layout_right.svg": 53156,
	"./layout_rightCover.svg": 70851,
	"./layout_rightCover_s.svg": 36159,
	"./layout_right_s.svg": 16236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44526;